import React from 'react';
import i18next from 'i18next';
import Icon from '../../../Icon/Icon';

import clockIcon from 'icons/clock.svg';
import mapIcon from 'icons/map.svg';
import lockOpenIcon from 'icons/lock-open.svg';
import lockCloseIcon from 'icons/lock-close.svg';

class EventTopInfo extends React.Component {
  render() {
    const { date, map, open, league, game, gameLogo } = this.props;
    return (
      <div className="event-top-info">
        <div className="event-top-info__date">
          <div className="event-top-info__title text-icon text-icon--right">
            {i18next.t('event_info.date')}
            <Icon glyph={clockIcon} className="text-icon__icon" />
          </div>
          <div>{date}</div>
        </div>
        {map && (
          <div className="event-top-info__map">
            <div className="event-top-info__title text-icon text-icon--right">
              {i18next.t('event_info.maps')}
              <Icon glyph={mapIcon} className="text-icon__icon" />
            </div>
            <div>{map}</div>
          </div>
        )}
        <div className="event-top-info__status">
          <div className="event-top-info__title">
            {i18next.t('event_info.status_title')}
          </div>
          <div className="text-icon text-icon--right">
            {i18next.t(`event_info.status.${open ? 'open' : 'closed'}`)}
            <Icon
              glyph={open ? lockOpenIcon : lockCloseIcon}
              className="text-icon__icon"
            />
          </div>
        </div>
        <div className="event-top-info__league">
          <div className="event-top-info__title">
            {i18next.t('event_info.event')}
          </div>
          <div>{league}</div>
        </div>
        <div className="event-top-info__game">
          <div className="event-top-info__title">
            {i18next.t('event_info.game')}
          </div>
          <div className="text-icon">
            <img src={gameLogo} className="text-icon__icon" />
            {game}
          </div>
        </div>
      </div>
    );
  }
}

export default EventTopInfo;



// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventPage/EventTopInfo/EventTopInfo.jsx